import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  TabList,
  Tabs,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../../Store/hooks";
import { setModalOpen } from "../../../Store/ModalsReducer";
import { colors } from "../../../Theme";
import { ModalsName } from "../../../Store/ModalsReducer";
import MyProjectsTab from "./MyProjectsTab";
import FavoritesTab from "./FavoriteProjects";
import PublishedTab from "./PublishedProjects";
import { LoadUser_user } from "../../../__generated__/LoadUser";

const Projects = (props: { user: LoadUser_user | null }) => {
  const isOpen = useAppSelector(
    (state) => state.modals[ModalsName.PROJECTS].isOpen
  );
  const dispatch = useAppDispatch();

  return (
    <>
      <Button
        isFullWidth
        onClick={() =>
          dispatch(setModalOpen({ key: ModalsName.PROJECTS, value: true }))
        }
        variant="editor"
      >
        Проекты
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() =>
          dispatch(setModalOpen({ key: ModalsName.PROJECTS, value: false }))
        }
        size="custom"
        isCentered={true}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent maxH="80vh" w="80vw" bg={colors.badgeLight}>
          <ModalCloseButton />
          <ModalBody marginTop="4rem">
            <Tabs isLazy={true} variant="obeliski" isFitted>
              <TabList>
                {props.user && <Tab>Мои эскизы</Tab>}
                {props.user && <Tab>Избранное</Tab>}
                <Tab>Опубликованные</Tab>
              </TabList>
              <TabPanels>
                {props.user && (
                  <TabPanel>
                    <MyProjectsTab />
                  </TabPanel>
                )}
                {props.user && (
                  <TabPanel>
                    <FavoritesTab />
                  </TabPanel>
                )}
                <TabPanel>
                  <PublishedTab />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Projects;
